<template>
  <router-view />
</template>

<script>
export default {
  name: "RrhhMain",
};
</script>